import { VarType } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant, Input, RadioButtons } from "@swivl-mono/ui";
import { useState } from "react";
import ModalModel from "../../../../../Models/Modal/Modal.Model";

interface Props {
  createNewVariable: (v: NewVariableState) => void;
}

export interface NewVariableState {
  type: VarType, key: string, displayName: string, description: string, defaultValue: string
}

export const AddVariableModal = (props: Props) => {
  const [state, setState] = useState<NewVariableState>({ type: VarType.Location, key: "", displayName: "", description: "", defaultValue: "" })

  const saveClicked = () => {
    if (!state.key || state.key.length < 3) {
      alert("Key is required.")
      return
    }
    if (!state.displayName || state.displayName.length < 3) {
      alert("Display Name is required.")
      return
    }

    props.createNewVariable(state)
  }

  return <div className="AddVariableModal flex flex-col bg-white mb-10 p-5 rounded-md">
    <h3>Add New Variable</h3>
    <label>{state.type === "User" ? "UserVarKey:" : "LocationVarKey:"}</label>
    <b className="mb-2">{state.type === "User" ? "UserVarKey." : "LocationVarKey."}{state.key}</b>

    <label>VarKey</label>
    <b className="mb-2">VarKey.{state.type}{state.key}</b>
    <label>Type</label>
    <RadioButtons className="mb-2" options={[{ value: "User", label: "User" }, { value: "Location", label: "Location" }]} value={state.type} onOptionSelected={(option) => setState({ ...state, type: option.value } as NewVariableState)} />

    <div className="mt-3">
      <Input value={state.key} placeholder={"Key..."} onSet={(v) => setState({ ...state, key: v } as NewVariableState)} />

      <Input value={state.displayName} placeholder={"Display Name..."} onSet={(v) => setState({ ...state, displayName: v } as NewVariableState)} />
      <Input value={state.description} placeholder={"Description...be a good citizen and fill this out."} onSet={(v) => setState({ ...state, description: v } as NewVariableState)} />
      <Input value={state.defaultValue} placeholder={"Default Value..."} onSet={(v) => setState({ ...state, defaultValue: v } as NewVariableState)} />

      <Button variant={ButtonVariant.GHOST} onClick={() => ModalModel.hideModal()}>Cancel</Button>
      <Button color={ButtonColor.ORANGE} onClick={saveClicked}>Save</Button>
    </div>
  </div>;
}
